import { createEvent } from 'effector';
import { DoctorFilterRequest } from 'types';

export const onResetDoctors = createEvent<void>('onResetDoctors');
export const onGetDoctors = createEvent<DoctorFilterRequest>('onGetDoctors');
export const onSetDoctorFilter = createEvent<DoctorFilterRequest>('onSetDoctorFilter');
export const onAddPersonalDoctor = createEvent<string>('onAddPersonalDoctor');
